<!-- BEGIN: Subheader -->
<div class="m-subheader ">
    <div class="d-flex align-items-center">
        <div class="mr-auto">
            <h3 class="m-subheader__title m-subheader__title--separator">Pedidos</h3>
            <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                <li class="m-nav__item m-nav__item--home">
                    <a [routerLink]="''" class="m-nav__link m-nav__link--icon">
                        <i class="m-nav__link-icon la la-home"></i>
                    </a>
                </li>
                <li class="m-nav__separator">-</li>
                <li class="m-nav__item">
                    <a [routerLink]="'/orders'" class="m-nav__link">
                        <span class="m-nav__link-text">Pedidos</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>

<div class="m-content">
    <div class="row">
        <div class="col-md-12">
            <!--begin::Portlet-->
            <div class="m-portlet m-portlet--mobile">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <h3 class="m-portlet__head-text">
                                Pedidos
                            </h3>
                        </div>
                    </div>
                </div>
                <div class="m-portlet__body">
                    <div class="table-responsive">
                        <!--begin: Datatable -->
                        <table datatable [dtOptions]="dtOptions"
                               class="table table-striped- table-bordered table-hover table-checkable">
                            <thead>
                            <tr>
                                <th>Fecha</th>
                                <th>Código</th>
                                <th>Monto de Delivery</th>
                                <th>Total</th>
                                <th>Total Final</th>
                                <th>Método de Pago</th>
                                <th>Estado</th>
                                <th>Acciones</th>
                            </tr>
                            </thead>
                            <tbody *ngIf="orders?.length != 0">
                            <tr *ngFor="let order of orders">
                                <td>{{ order.created_at | date:'dd/MM/YYYY HH:mm' }}</td>
                                <td>{{ order.code }}</td>
                                <td>{{ order.delivery_amount | currency: 'S/ '}}</td>
                                <td>{{ order.total | currency: 'S/ '}}</td>
                                <td>{{ (order.total + order.delivery_amount) | currency: 'S/ '}}</td>
                                <td>{{ order.payment_method_nice }}</td>
                                <td>{{ order.status_nice }}</td>
                                <td class="d-flex justify-content-around">
                                    <button (click)="show(order)"
                                            class="m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
                                            title="Ver Detalles">
                                        <i class="la la-eye"></i>
                                    </button>
                                    <button class="btn btn-confirm" [ngClass]="{'btn-success': (order.status != 4 && order.status != 1 && order.status != 8 && order.status != 5), 'inactive': (order.status == 4 || order.status == 1 || order.status == 8 || order.status == 5)}" (click)="onStatus(order)">Confirmar</button>
                                </td>
                            </tr>
                            </tbody>
                            <tbody *ngIf="orders?.length == 0">
                            <tr>
                                <td colspan="7" class="no-data-available">No data!</td>
                            </tr>
                            <tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
